<template>
    <div id="secondary">
        <div class="header">
            <img src="@assets/imgs/sec-top.png" alt />
        </div>
        <div class="content">
            <router-view />
        </div>
        <Footer :cdnPrefix="cdnPrefix"></Footer>
    </div>
</template>

<script>
import Footer from "./Footer.vue";
export default {
    name: "Secondary",
    components: {
        Footer
    },
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
        cdnPrefix: {
            type: String,
            default: ""
        }
    },
    data() {
        return {};
    },
    watch: {},
    mounted() {},
    methods: {}
};
</script>

<style lang="scss">
#secondary {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    min-height: 100%;
    background: url("~@assets/imgs/sec-bg.png") repeat;
    .header {
        img {
            width: 100%;
        }
    }
    .content {
        width: 80%;
        margin: 0 auto;
        background: url("~@assets/imgs/sec-cont-bg.png") repeat;
    }
}
@media screen and (max-width: 768px) {
    #secondary {
        .content {
            width: 100%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Secondary.vue